import { render, staticRenderFns } from "./GraficoEnviosWhatsapp.vue?vue&type=template&id=d28db934"
import script from "./GraficoEnviosWhatsapp.vue?vue&type=script&lang=js"
export * from "./GraficoEnviosWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports